import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=4de19ac8&scoped=true"
import script from "./Dates.vue?vue&type=script&lang=ts"
export * from "./Dates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de19ac8",
  null
  
)

export default component.exports